export default () => {

    // Open video overlay
    $('.video-banner-panel-button').on('click', function() {
        $(this).parents('.video-banner').addClass('is-active');
    });

    // Close video overlay
    $('.video-banner-overlay-close').on('click', function() {
        $(this).parents('.video-banner').removeClass('is-active');
    });
}